module.exports = __webpack_public_path__ + "static/img/HT-MT300.c78edc4f.jpg";